import React from 'react';

import media1 from '../images/media/1.png';
import media2 from '../images/media/2.png';
import media3 from '../images/media/3.png';
import media4 from '../images/media/4.png';
import media5 from '../images/media/5.png';
import media6 from '../images/media/6.jpeg';
import media7 from '../images/media/7.png';
import media8 from '../images/media/8.png';
import media9 from '../images/media/9.png';
import slide1 from '../images/tempo.png';

const Content = () => {
  return (
    <section className="text-gray-600 body-font">
  <div className="container px-5 py-24 mx-auto">
      <div className="w-full" align="center">

  <h1 className='lg:text-5xl md:text-3xl sm:text-2xl text-lg font-black mb-14 capitalize'>
  Diliput Oleh Puluhan Media di Indonesia
      </h1>
      </div>
      <br /><br />
    <div className="flex flex-wrap -m-3">
      <div className="lg:w-1/3 md:w-1/2 p-1 w-full">
        <a className="block relative h-48 rounded overflow-hidden lg:px-20 px-10">
          <img alt="ecommerce" className="object-cover object-center w-auto h-auto block" src={media1} />
        </a>
      </div>
      <div className="lg:w-1/3 md:w-1/2 p-1 w-full">
        <a className="block relative h-48 rounded overflow-hidden lg:px-20 px-10">
          <img alt="ecommerce" className="object-cover object-center w-auto h-auto block" src={media2} />
        </a>
      </div>
      <div className="lg:w-1/3 md:w-1/2 p-1 w-full">
        <a className="block relative h-48 rounded overflow-hidden lg:px-20 px-10">
          <img alt="ecommerce" className="object-cover object-center w-auto h-auto block" src={media3} />
        </a>
      </div>
      <div className="lg:w-1/3 md:w-1/2 p-1 w-full">
        <a className="block relative h-48 rounded overflow-hidden lg:px-20 px-10">
          <img alt="ecommerce" className="object-cover object-center w-auto h-auto block" src={media4} />
        </a>
      </div>
      <div className="lg:w-1/3 md:w-1/2 p-1 w-full">
        <a className="block relative h-48 rounded overflow-hidden lg:px-20 px-10">
          <img alt="ecommerce" className="object-cover object-center w-auto h-auto block" src={media5} />
        </a>
      </div>
      <div className="lg:w-1/3 md:w-1/2 p-1 w-full">
        <a className="block relative h-48 rounded overflow-hidden lg:px-20 px-10">
          <img alt="ecommerce" className="object-cover object-center w-auto h-auto block" src={media6} />
        </a>
      </div>
      <div className="lg:w-1/3 md:w-1/2 p-1 w-full">
        <a className="block relative h-48 rounded overflow-hidden lg:px-20 px-10">
          <img alt="ecommerce" className="object-cover object-center w-auto h-auto block" src={media7} />
        </a>
      </div>
      <div className="lg:w-1/3 md:w-1/2 p-1 w-full">
        <a className="block relative h-48 rounded overflow-hidden lg:px-20 px-10">
          <img alt="ecommerce" className="object-cover object-center w-auto h-auto block" src={media8} />
        </a>
      </div>
      <div className="lg:w-1/3 md:w-auto p-1 w-full">
        <a className="block relative h-48 rounded overflow-hidden lg:px-20 px-10">
          <img alt="ecommerce" className="object-cover object-center w-auto h-auto block" src={media9} />
        </a>
      </div>
    </div>
  </div>
  <div className="container px-5 py-24 mx-auto">
  <div className="lg:w-full md:w-1/2 w-5/6 mb-10 md:mb-0 flex justify-center">
    <img className="w-full h-full lg:max-w-2xl rounded-lg shadow-md" alt="hero" src={slide1} />
  </div>
  <div className="flex justify-center mt-5">
    <a
      href="https://tekno.tempo.co/read/1722394/mengenal-homeschooling-komunitas-sekolah-fleksibel-sesuai-minat-dan-bakat-siswa"
      target="_blank"
      rel="noopener noreferrer"
      className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded inline-block"
    >
      Baca Artikel Disini
    </a>
  </div>
</div>

</section>


  );
};

export default Content;
